import { BrowserRouter as Router, Switch } from "react-router-dom";

import Bonificacao from "../pages/cadastros/bonificacao";
import Cliente from "../pages/cadastros/cliente";
import ClienteInstalacao from "../pages/cadastros/clienteinstalacao";
import Concessionaria from "../pages/usinas/concessionaria";
import ConfiguracaoAlarme from "../pages/alarmes/configuracaoalarme";
import DetalharHistoricoProcessamento from "../pages/rebalance/historicoProcessamento/detalhar";
import Event from "../utils/events";
import FaturaCliente from "../pages/faturamento/faturacliente";
import FaturaConcessionaria from "../pages/faturamento/faturaconcessionaria";
import FaturaInstalacao from "../pages/faturamento/faturainstalacao";
import FaturaPrevista from "../pages/faturamento/faturaprevista";
import FaturaUsina from "../pages/faturamento/faturausina";
import GeracaoUsinas from "../pages/rebalance/geracaoUsinas";
import GerarRelatorios from "../pages/relatorios/gerarrelatorios";
import GrupoAlarme from "../pages/alarmes/grupoalarme";
import HistoricoProcessamento from "../pages/rebalance/historicoProcessamento";
import HistoricoSaldo from "../pages/faturamento/historicosaldo";
import Home from "../pages/home";
import LancamentoManual from "../pages/lancamentomanual/lancamento";
import Listagemrelatorios from "@/pages/relatorios/listagemrelatorios";
import ManutencaoInstalacao from "../pages/cadastros/manutencaoInstalacao";
import MotivoLancamentoManual from "../pages/lancamentomanual/motivo";
import MotivoMovimentacao from "../pages/rebalance/motivoMovimentacao";
import MovimentacaoUcs from "../pages/rebalance/movimentacaoUcs";
import Parametros from "../pages/cadastros/parametros";
import Parceiro from "../pages/cadastros/parceiro";
import Rebalance from "../pages/rebalance/rebalance";
import RebalanceDetalhar from "../pages/rebalance/rebalance/detalhar";
import RevisaoCota from "../pages/usinas/revisaocotas";
import RevisaoInstalacao from "../pages/usinas/revisaoinstalacao";
import Route from "./Route";
import Saldos from "../pages/faturamento/saldos";
import Usina from "../pages/usinas/usina";
import Usuario from "../pages/cadastros/usuario";
import FaturaSaldoChurn from "@/pages/cobrancasaldochurn/cobrancasaldochurn";
import CalculoRebate from "@/pages/analisetarifaria/calculorebate";
import ParametrosRebate from "@/pages/analisetarifaria/parametrosrebate";
import DetalharRebate from "@/pages/analisetarifaria/calculorebate/detalhar";
import CadastroModelo from "@/pages/capturafatura/cadastromodelo";
import CadastroCampos from "@/pages/capturafatura/cadastrocampos";
import CadastroPosicoes from "@/pages/capturafatura/cadastroposicoes";
import HistoricoExclusaoInstalacao from "@/pages/cadastros/historicoExclusaoInstalacao";
import CampanhasComerciais from "../pages/cadastros/campanhascomerciais";
import Marcadores from "../pages/cadastros/marcadores";


export default function Routes() {
    const tokenStorageName = process.env.REACT_APP_API_SENSEDIA_TOKEN_STORAGE ?? "";
    const token = localStorage.getItem(tokenStorageName);

    if (!token) {
        Event.emit("logout", "Você não está conectado em nossos servidores");
    }

    return (
        <Router>
            <Switch>
                <Route path="/" exact component={Home} />

                {/* Cadastros */}
                <Route path="/cadastros/cliente" component={Cliente} />
                <Route path="/cadastros/clienteinstalacao" component={ClienteInstalacao} />
                <Route path="/cadastros/parceiro" component={Parceiro} />
                <Route path="/cadastros/manutencaoinstalacao" component={ManutencaoInstalacao} />
                <Route path="/cadastros/bonificacao" component={Bonificacao} />
                <Route path="/cadastros/parametros" component={Parametros} />
                <Route path="/cadastros/usuarios" component={Usuario} />
                <Route path="/cadastros/historicoexclusao" component={HistoricoExclusaoInstalacao} />
                <Route path="/cadastros/campanhascomerciais" component={CampanhasComerciais} />
                <Route path="/cadastros/marcadores" component={Marcadores} />


                {/* Faturamento */}
                <Route path="/faturamento/faturausina" component={FaturaUsina} />
                <Route path="/faturamento/faturainstalacao" component={FaturaInstalacao} />
                <Route path="/faturamento/faturacliente" component={FaturaCliente} />
                <Route path="/faturamento/faturaconcessionaria" component={FaturaConcessionaria} />
                <Route path="/faturamento/saldos" component={Saldos} />
                <Route path="/faturamento/historicosaldo" component={HistoricoSaldo} />
                <Route path="/faturamento/faturaprevista" component={FaturaPrevista} />

                {/* Saldo Churn */}
                <Route path="/cobrancasaldochurn/cobrancasaldochurn" component={FaturaSaldoChurn} />

                {/* Lançamento manual */}
                <Route path="/lancamentomanual/motivo" component={MotivoLancamentoManual} />
                <Route path="/lancamentomanual/lancamento" component={LancamentoManual} />

                {/* Rebalance */}
                <Route path="/rebalance/geracaousinas" component={GeracaoUsinas} />
                <Route path="/rebalance/motivomovimentacao" component={MotivoMovimentacao} />
                <Route path="/rebalance/movimentacaoUcs" component={MovimentacaoUcs} />
                <Route path="/rebalance/rebalance" component={Rebalance} />
                <Route path="/rebalance/detalhar" component={RebalanceDetalhar} />
                <Route path="/rebalance/historicoProcessamento" component={HistoricoProcessamento} />
                <Route path="/rebalance/detalharHistorico" component={DetalharHistoricoProcessamento} />

                {/* Usinas */}
                <Route path="/usinas/usina" component={Usina} />
                <Route path="/usinas/concessionaria" component={Concessionaria} />
                <Route path="/usinas/revisaocotas" component={RevisaoCota} />
                <Route path="/usinas/revisaoinstalacao" component={RevisaoInstalacao} />

                {/* Alarmes  */}
                <Route path="/alarme/grupoalarme" component={GrupoAlarme} />
                <Route path="/alarme/configuracaoalarme" component={ConfiguracaoAlarme} />

                {/* Relatorios */}
                <Route path="/relatorios/gerarrelatorios" component={GerarRelatorios} />
                <Route path="/relatorios/listagemrelatorios" component={Listagemrelatorios} />

                {/* Análise Tarifária */}
                <Route path="/analisetarifaria/calculorebate" component={CalculoRebate} />
                <Route path="/analisetarifaria/detalhesrebate" component={DetalharRebate} />
                <Route path="/analisetarifaria/parametrosrebate" component={ParametrosRebate} />

                {/* Configurações de Faturas */}
                <Route path="/capturafatura/cadastromodelo" component={CadastroModelo} />
                <Route path="/capturafatura/cadastrocampo" component={CadastroCampos} />
                <Route path="/capturafatura/cadastroposicao" component={CadastroPosicoes} />
            </Switch>
        </Router>
    );
}
